import httpService from "app/services/httpService";
import config from "config.json";

const apiUrl = config.apiUrl;

const addMember = async (member) => {
  try {
    const url = `${apiUrl}/members`;
    const { data } = await httpService.post(url, member);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateMember = async (memId, member) => {
  try {
    const url = `${apiUrl}/members/update/${memId}`;
    const { data } = await httpService.post(url, member);
    return data;
  } catch (error) {
    throw error;
  }
};

const getMerchantAndDistributorById = async (id, memberType) => {
  try {
    const url = `${apiUrl}/members/${memberType}/${id}`;
    const { data } = await httpService.get(url);
    return data.data;
  } catch (error) {
    throw error;
  }
};

const getMerchant = async (queryString) => {
  try {
    const url = `${apiUrl}/members/merchants${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getPendingMerchants = async (queryString) => {
  try {
    const url = `${apiUrl}/members/pending-signup-members-list${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const exportMerchant = async (queryString) => {
  try {
    const url = `${apiUrl}/members/merchants/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const getMerchantForDistributor = async (queryString) => {
  try {
    const url = `${apiUrl}/members/merchants${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const searchMerchantForAdmin = async (searchText) => {
  try {
    const url = `${apiUrl}/members/merchants/search${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const searchMerchantForDistributor = async (searchText) => {
  try {
    const url = `${apiUrl}/members/merchants/search-by-distributor${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getDistributor = async (queryString) => {
  try {
    const url = `${apiUrl}/members/distributors${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const depositAmount = async (value) => {
  try {
    const url = `${apiUrl}/members/deposit-balance`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const depositAmountByDistributor = async (value) => {
  try {
    const url = `${apiUrl}/members/distributor-deposit-balance`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const resetPassword = async (value) => {
  try {
    const url = `${apiUrl}/members/reset-password`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const StatusUpdateHandler = async (value) => {
  try {
    const url = `${apiUrl}/members/member-status`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const pendingStatusApprove = async (value) => {
  try {
    const url = `${apiUrl}/members/update-signUp-member-status/${value}`;
    const { data } = await httpService.post(url, null);
    return data;
  } catch (error) {
    throw error;
  }
};
const pendingStatusDecline = async (value) => {
  try {
    const url = `${apiUrl}/members/delete-member-status/${value}`;
    const { data } = await httpService.post(url, null);
    return data;
  } catch (error) {
    throw error;
  }
};
const exportRequestedMerchant = async (queryString) => {
  try {
    const url = `${apiUrl}/members/signup-members-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const releasePnrHandler = async (value) => {
  try {
    const url = `${apiUrl}/flight/release-pnr`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const rejectPnrHandler = async (value) => {
  try {
    const url = `${apiUrl}/flight/reject-pnr`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const getNotification = async (queryString) => {
  try {
    const url = `${apiUrl}/notification/all?${queryString}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const postNotification = async (value) => {
  try {
    const url = `${apiUrl}/notification`;
    const data = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateNotification = async (value) => {
  try {
    const url = `${apiUrl}/notification/update`;
    const data = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteNotification = async (value) => {
  try {
    const url = `${apiUrl}/notification/delete/${value}`;
    const data = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getNotificationById = async (value) => {
  try {
    const url = `${apiUrl}/notification/notifications/${value}`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const exportManualCRDR = async (queryString) => {
  try {
    const url = `${apiUrl}/members/manual-debit/credit-report/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const sendOtp = async () => {
  try {
    const url = `${apiUrl}/authenticate/transaction-otp/MANUAL_DEBIT_CREDIT`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const memberCreditDebitList = async (queryString) => {
  try {
    const url = `${apiUrl}/members/member-debit-credit-list${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const exportCreditDebitList = async (queryString) => {
  try {
    const url = `${apiUrl}/members/member-debit-credit-list/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

const exportApiUserMerchant = async (queryString) => {
  try {
    const url = `${apiUrl}/apipartner/member/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getApiUserMerchant = async (queryString) => {
  try {
    const url = `${apiUrl}/apipartner/all-merchant-under-api-user${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getSupplier = async (queryString) => {
  try {
    const url = `${apiUrl}/members/supplier${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const getDisputeAcc = async (FromDate, ToDate) => {
  try {
    const url = `${apiUrl}/members/member-opening-closing-data?FromDate=${FromDate}&ToDate=${ToDate}`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getOperationUsersList = async (query) => {
  try {
    const url = `${apiUrl}/authenticate/operation-users${
      query ? `?${query}` : ""
    }`;
    const { data } = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
const getCountryDetails = async (value) => {
  const request = await httpService.get(
    `${apiUrl}/members/get-country?searchText=${value}`
  );
  return request;
};

const refundAmount = async (value) => {
  const url = `${apiUrl}/flight/refund-booked-amount`;
  const request = await httpService.post(url, value);
  return request;
};

const userListResetPassword = async (value) => {
  try {
    const url = `${apiUrl}/members/user-password-reset`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const getStateDetails = async () => {
  const request = await httpService.get(`${apiUrl}/state/all`);
  return request;
};
const totalAmountService = async (value) => {
  try {
    const url = `${apiUrl}/members/accouont-summery`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const getSystemDetails = async (value) => {
  try {
    const request = await httpService.get(
      `${apiUrl}/members/member-system-details/${value}`
    );
    return request;
  } catch (error) {
    throw error;
  }
};
const postSystemDetails = async (value) => {
  try {
    const url = `${apiUrl}/members/manage-system-config`;
    const { data } = await httpService.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  userListResetPassword,
  refundAmount,
  getCountryDetails,
  getStateDetails,
  addMember,
  updateMember,
  getMerchantAndDistributorById,
  getMerchant,
  getPendingMerchants,
  exportMerchant,
  getMerchantForDistributor,
  searchMerchantForAdmin,
  searchMerchantForDistributor,
  getDistributor,
  depositAmount,
  depositAmountByDistributor,
  resetPassword,
  StatusUpdateHandler,
  pendingStatusApprove,
  pendingStatusDecline,
  exportRequestedMerchant,
  releasePnrHandler,
  rejectPnrHandler,
  getNotification,
  postNotification,
  updateNotification,
  deleteNotification,
  getNotificationById,
  exportManualCRDR,
  sendOtp,
  memberCreditDebitList,
  exportCreditDebitList,
  exportApiUserMerchant,
  getApiUserMerchant,
  getSupplier,
  getDisputeAcc,
  getOperationUsersList,
  totalAmountService,
  getSystemDetails,
  postSystemDetails,
};
